var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyIconPrivateroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(558 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-558 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.563,3.489A.572.572,0,0,0,1,4.069V15.126a.572.572,0,1,0,1.144,0v-.572H16.632v.572a.572.572,0,1,0,1.144,0v-3.05a1.343,1.343,0,0,0-1.334-1.334h-.163A2.215,2.215,0,0,0,16.632,9.6,2.3,2.3,0,0,0,14.344,7.31h-6.1a2.281,2.281,0,0,0-1.643.7C6.592,8,6.584,7.99,6.574,7.979A2.086,2.086,0,0,0,5,7.31a2.086,2.086,0,0,0-1.571.669,2.2,2.2,0,0,0-.075,2.763H2.144V4.069a.572.572,0,0,0-.581-.58ZM5,8.454a.87.87,0,0,1,.716.284,1.063,1.063,0,0,1,0,1.337A.87.87,0,0,1,5,10.36a.87.87,0,0,1-.716-.284,1.063,1.063,0,0,1,0-1.337A.87.87,0,0,1,5,8.454Zm3.241,0h6.1a1.144,1.144,0,1,1,0,2.288H7.1V9.6A1.135,1.135,0,0,1,8.244,8.454Zm-6.1,3.431h14.3a.182.182,0,0,1,.191.191V13.41H2.144Z",
    transform: "translate(558.612 773.794)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconPrivateroom);
export default __webpack_public_path__ + "static/media/property-icon-privateroom.c2059231a4f5fcdc5263038bd882204e.svg";
export { ForwardRef as ReactComponent };